import { Component, inject, input, signal, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";
import {MatCard, MatCardTitle} from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { TranslocoPipe } from "@jsverse/transloco";
import { LinkGen } from "../../../../shared/constants/loren-routes.constants";
import { LorenAsset } from "../../../loren-assets/interfaces/loren-asset.interface";
import { LorenPageContentComponent } from "../../../../shared/modules/loren-page-content/loren-page-content.component";
import { LorenAssetCardComponent } from "../../../../shared/modules/loren-asset-card/loren-asset-card.component";
import {
  LorenAuthenticationService
} from "../../../../shared/services/loren-authentication-service/loren-authentication.service";
import { LorenUtilsService } from "../../../../shared/services/loren-utils-service/loren-utils.service";
import {
  LorenDetailsOutletService
} from "../../../../shared/services/loren-details-outlet-service/loren-details-outlet.service";
import { LorenFiltersComponent } from "../../../../shared/modules/loren-filters/loren-filters.component";
import { MatButton } from "@angular/material/button";

@Component({
    imports: [
        ReactiveFormsModule,
        MatIcon,
        MatCard,
        MatInputModule,
        MatMenuModule,
        TranslocoPipe,
        LorenPageContentComponent,
        LorenAssetCardComponent,
        LorenFiltersComponent,
        MatButton,
        MatCardTitle,
    ],
  selector: "loren-home-selected-assets",
  styleUrl: "./loren-home-selected-assets.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./loren-home-selected-assets.component.html",
})
export class LorenHomeSelectedAssetsComponent {
  private router = inject(Router);
  private authService = inject(LorenAuthenticationService);
  private detailsOutletService = inject(LorenDetailsOutletService);

  assets = input.required<LorenAsset[]>();
  error = signal<boolean>(false);
  selectedAssetsIds = signal<number[]>(LorenUtilsService.getSelectedAssets(this.authService.userId) ?? []);

  handleAssetRemove(id) {
    this.selectedAssetsIds.update(ids => ids.filter(x => x !== id));
    LorenUtilsService.setSelectedAssets(this.selectedAssetsIds(), this.authService.userId);
  }

  handleDefineAsset() {
    this.detailsOutletService.resetDetailsOutlet();

    this.router.navigateByUrl(LinkGen.Assets.New());
  }

  saveCheckedAssets(selectedAssets) {
    const ids = Array.from(selectedAssets.entries())
      .filter((i) => i[1])
      .map((i) => i[0] as number);
    this.selectedAssetsIds.set(ids);
    LorenUtilsService.setSelectedAssets(ids, this.authService.getUserInfo().id);
  }

  getAssetsForFilter() {
    return this.assets().map((a) => ({ key: a.name, value: a.id }));
  }

  getSelectedIds() {
    return this.selectedAssetsIds();
  }
}
